/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Row, Col, Form, Icon, Input, InputNumber, message } from "antd";
import GenericSelectorBranches from "../../components/GenericSelectorBranches";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import ReportShowButton from "../../components/ReportShowButton";
import moment from "moment";
import SelectorZBranchList from "../../components/SelectorZBranchList";
import GenericTable from "../../components/GenericTable";

const DOW_HE = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];


// 30110 מספר Z
// 30111 מתאריך ושעה
// 30112 עד תאריך ושעה
// 30113 חיובים
// 30114 זיכויים
// 30115 פעולות
// 30116 תאריך ושעה
// 30117 אסמכתא
// 30118 שם לקוח
// 30119 סה"כ שורה כולל מעמ
// 30120 שם עובד
// 30121 הצג מסמך
// 30122 מסמך
// 30123 סה"כ
// 30124 שם פריט
// 30125 פירוט Z
// 30126 מסמכים קשורים
// 30127 שורות פריט

// class TipsDisplay extends Component {
//     constructor(props: Props) {
//         super(props);
//         this.state = {
//             _branchId: '',
//             _branchName: '',
//             _fromZ: '',
//             _toZ: '',
//             _fromZStart: null,
//             _fromZEnd: null,
//             _toZStart: null,
//             _toZEnd: null,

//             btnZ: '',
//             zListData: [],
//             inputZFocus: null, // "from" / "to"

//             // main data
//             dataset: [],
//             branchName: '',
//             branchCode: '',

//             // modals
//             modalOpen: false,
//             modalDetail: null,      // { rows: [], zNum, dateFrom, dateTo }
//             modalDocList: null,     // { docs: [], custName }
//             modalCoToLines: null,   // { lines: [], custName }
//             loading: false,

//         };

//         this.id = "TIPS_DISPLAY";

//         this.api = {
//             get: "get_tips_display",
//             getLastZ: "get_branch_last_z_range",
//             getMonthZ: "get_branch_month_z_range",
//             getPrevMonthZ: "get_branch_prev_month_z_range",
//             getDocsByRef: "get_documents_by_ref2_and_customer",
//         };

//         if (props.data[this.id] === undefined) props.data[this.id] = { dataset: [] };
//     }

//     static contextType = LangContext;

//     getText = (id) => {
//         return this.context.get(id) || '[' + id + ']';
//     }

//     componentDidUpdate() {
//         document.title = "Cash On Tab - " + this.getText(22529);
//     }


//     // ─── Z-range shortcuts ───────────────────────────────────────────────────
//     zSetValues = (from, to, btnZ) => {
//         let res = {
//             _fromZ: from.num,
//             _toZ: to.num,
//             _fromZStart: moment(from.start).format("YYYY-MM-DD"),
//             _fromZEnd: moment(from.end).format("YYYY-MM-DD"),
//             _toZStart: moment(to.start).format("YYYY-MM-DD"),
//             _toZEnd: moment(to.end).format("YYYY-MM-DD"),
//             btnZ,
//             inputZFocus: null
//         };
//         if (parseInt(from.num) > parseInt(to.num)) {
//             res._fromZ = to.num;
//             res._toZ = from.num;
//             res._fromZStart = moment(from.start).format("YYYY-MM-DD");
//             res._fromZEnd = moment(from.end).format("YYYY-MM-DD");
//             res._toZStart = moment(to.start).format("YYYY-MM-DD");
//             res._toZEnd = moment(to.end).format("YYYY-MM-DD");
//         }
//         if (res._fromZ && res._toZ && moment(res._fromZStart).add(1, "year") < moment(res._toZEnd)) {
//             message.error(this.getText(22551));
//         } else {
//             this.setState(res);
//         }
//     }

//     fillLastZ = () => {
//         const { _branchId, zListData } = this.state;
//         let findLast = zListData.find(f => f.branch == _branchId);
//         if (!findLast) return;
//         this.zSetValues(findLast, findLast, 'last');
//     }

//     fillCurrentMonthZ = () => {
//         const { _branchId, zListData } = this.state;
//         let fitered = zListData.filter(f => f.branch == _branchId && moment(f.start, "YYYY-MM-DD").isSame(moment(), "month"));
//         if (!fitered[0]) return;
//         let _fromZ = fitered[0];
//         let _toZ = fitered[fitered.length - 1];
//         this.zSetValues(_fromZ, _toZ, 'curMonth');
//     }

//     fillPrevMonthZ = () => {
//         const { _branchId, zListData } = this.state;
//         let fitered = zListData.filter(f => f.branch == _branchId && moment(f.start, "YYYY-MM-DD").isSame(moment().subtract(1, "month"), "month"));
//         if (!fitered[0]) return;
//         let _fromZ = fitered[0];
//         let _toZ = fitered[fitered.length - 1];
//         this.zSetValues(_fromZ, _toZ, 'prevMonth');
//     }


//     // ─── Detail modal ────────────────────────────────────────────────────────

//     openDetail = (record) => {
//         this.sendAPI("get_tips_detail_by_z", { _branchId: this.state._branchId, _zNum: record._zNum }, ob => {
//             let rows = [];
//             if (ob.data) {
//                 ob.data.split("\r").forEach(x => {
//                     let y = x.split("\f");
//                     rows.push({
//                         key: y[0] + "_" + y[1],
//                         _datetime: y[0],
//                         _ref1: y[1],
//                         _custName: y[2],
//                         _lineSum: parseFloat(y[3]) || 0,
//                         _empName: y[4],
//                         _docNum: y[5],
//                         _docType: y[6],
//                         _docPos: y[7],
//                         _ref2: y[8],
//                         _custId: y[9],
//                     });
//                 });
//             }
//             this.setState({ modalDetail: { rows, zNum: record._zNum, dateFrom: record._dateFrom, dateTo: record._dateTo } });
//         });
//     }

//     // ─── Document icon logic ─────────────────────────────────────────────────

//     handleDocIcon = (row) => {
//         if (this.props.isCoto) {
//             this.openCoToDocLines(row);
//             return;
//         }
//         if (!row._ref2) {
//             // single doc – ReportShowButton handles display directly
//             return;
//         }
//         this.sendAPI(this.api.getDocsByRef, { _ref2: row._ref2, _custId: row._custId }, ob => {
//             let docs = [];
//             if (ob.data) {
//                 ob.data.split("\r").forEach(x => {
//                     let y = x.split("\f");
//                     docs.push({
//                         key: y[0],
//                         _docNum: y[0],
//                         _datetime: y[1],
//                         _custName: y[2],
//                         _totalWithTax: parseFloat(y[3]) || 0,
//                         _docType: y[4],
//                         _docPos: y[5],
//                     });
//                 });
//             }
//             if (docs.length > 1) {
//                 this.setState({ modalDocList: { docs, custName: row._custName } });
//             }
//             // if only 1 doc, ReportShowButton already opened it
//         });
//     }

//     openCoToDocLines = (row) => {
//         this.sendAPI("get_coto_doc_lines_by_ref", { _ref2: row._ref2, _custId: row._custId }, ob => {
//             let lines = [];
//             let custName = row._custName;
//             if (ob.data) {
//                 ob.data.split("\r").forEach(x => {
//                     let y = x.split("\f");
//                     lines.push({
//                         key: y[0] + "_" + y[1],
//                         _docNum: y[0],
//                         _datetime: y[1],
//                         _itemName: y[2],
//                         _lineSum: parseFloat(y[3]) || 0,
//                     });
//                     if (y[4]) custName = y[4];
//                 });
//             }
//             this.setState({ modalCoToLines: { lines, custName } });
//         });
//     }

//     // ─── Helpers ─────────────────────────────────────────────────────────────

//     formatSum = (n) => {
//         if (n === undefined || n === null) return "0.00";
//         return n.toLocaleString("he-IL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     }

//     formatDateDow = (dt) => {
//         if (!dt) return "";
//         const m = moment(dt);
//         const dow = DOW_HE[m.day()];
//         return m.format("DD/MM/YYYY") + " " + dow.charAt(0) + "'";
//     }

//     formatDateTime = (dt) => {
//         if (!dt) return "";
//         return moment(dt).format("DD/MM/YYYY HH:mm");
//     }

//     sendAPI = (script, data, sCal) => {
//         let user = new User(this.props.user.token, this.props.user.companyCode);
//         let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
//         job.setInput(data);
//         job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
//     }

//     // ─── Render ──────────────────────────────────────────────────────────────

//     render() {
//         const gt = this.getText;

//         const { _branchId, _fromZ, _toZ, dataset, branchCode, branchName,
//             modalOpen, modalDetail, modalDocList, modalCoToLines,
//             loading
//         } = this.state;

//         const divStyle = {
//             align: "center",
//             dir: "rtl",
//             padding: "2% 2% 2% 2%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "100%",
//             flexDirection: "column",
//         };

//         return (
//             <div style={divStyle}>
//                 <Card
//                     title={<PageToolbar title={gt(22529)} showsearch={false} actionButtons={[]} />}
//                     bordered={true}
//                     style={{ width: window.innerWidth < 600 ? "95%" : 500 }}
//                     headStyle={{ paddingLeft: 8, paddingRight: 8, marginTop: 4, height: 56 }}
//                     actions={[
//                         <Button type="primary" onClick={() => { this.setState({ modalOpen: true }) }}>{gt(22536)}</Button>,
//                         <Button onClick={() => this.setState({ _branchId: '', _fromZ: '', _toZ: '' })}>{gt(22537)}</Button>
//                     ]}
//                 >
//                     <Form.Item label={gt(22530)} >
//                         <GenericSelectorBranches
//                             {...this.props}
//                             value={_branchId}
//                             onChange={() => { }}
//                             onChangeGetDetailed={({ code, name }) => {
//                                 this.setState({ _branchId: code, _branchName: name }, this.fillLastZ)
//                             }}
//                         />
//                     </Form.Item>
//                     <Form.Item label={gt(22531)} >
//                         <Icon type="unordered-list" style={{ marginRight: 8 }} onClick={() => this.setState({ inputZFocus: "from" })} />
//                         <Input style={{ width: 120, display: "inline-block" }} disabled={!_branchId} value={_fromZ} />
//                         {" "}  מ  {this.state._fromZStart} עד {this.state._fromZEnd}
//                     </Form.Item>
//                     <Form.Item label={gt(22532)} >
//                         <Icon type="unordered-list" style={{ marginRight: 8 }} onClick={() => this.setState({ inputZFocus: "to" })} />
//                         <Input style={{ width: 120, display: "inline-block" }} disabled={!_branchId} value={_toZ} />
//                         {" "}   מ   {this.state._toZStart} עד {this.state._toZEnd}
//                     </Form.Item>

//                     <Form.Item>
//                         <Row>
//                             {[
//                                 { key: "last", text: gt(22533), onClick: this.fillLastZ },
//                                 { key: "curMonth", text: gt(22534), onClick: this.fillCurrentMonthZ },
//                                 { key: "prevMonth", text: gt(22535), onClick: this.fillPrevMonthZ },
//                             ].map(btn => (
//                                 <Col span={8} key={btn.key}>
//                                     <div style={{ textAlign: "center" }}>
//                                         <Button
//                                             disabled={!_branchId}
//                                             type={this.state.btnZ === btn.key ? 'primary' : 'default'}
//                                             onClick={() => this.setState({ btnZ: btn.key }, btn.onClick)}>
//                                             {btn.text}
//                                         </Button>
//                                     </div>
//                                 </Col>
//                             ))}
//                         </Row>
//                     </Form.Item>

//                 </Card>

//                 <SelectorZBranchList
//                     {...this.props}
//                     isModalOnly
//                     visible={this.state.inputZFocus !== null}
//                     getZListOnOpen={list => { this.setState({ zListData: list }) }}
//                     filters={{ zNumber: null, branchId: _branchId }}
//                     onChange={obj => {
//                         let res = { num: obj.zNumber, start: obj.StartDate, end: obj.EndDate }
//                         let from = this.state.inputZFocus === "from" ? res : { num: this.state._fromZ, start: this.state._fromZStart, end: this.state._fromZEnd };
//                         let to = this.state.inputZFocus === "to" ? res : { num: this.state._toZ, start: this.state._toZStart, end: this.state._toZEnd };
//                         this.zSetValues(from, to, null);
//                     }}
//                 />

//                 <GenericModal
//                     visible={modalOpen}
//                     title={<>{gt(22554)} {this.state._branchId} {this.state._branchName}</>}
//                     onCancel={() => this.setState({ modalOpen: false })}
//                     width={800}
//                 >
//                     {modalOpen && <GenericTable
//                         {...this.props}
//                         tableOnly
//                         id={this.id}
//                         getApi={this.api.get}
//                         filters={{ _branchId, _fromZ, _toZ }}
//                         columns={[
//                             { title: gt(30116), dataIndex: '_datetime', key: '_datetime', render: this.formatDateTime },
//                             { title: gt(30117), dataIndex: '_ref1', key: '_ref1' },
//                             { title: gt(30118), dataIndex: '_custName', key: '_custName' },
//                             { title: gt(30119), dataIndex: '_lineSum', key: '_lineSum', render: this.formatSum },
//                             { title: gt(30120), dataIndex: '_empName', key: '_empName' },
//                             {
//                                 title: gt(30121), dataIndex: '_docNum', key: '_docNum', render: (text, record) => {
//                                     if (!record._ref2) {
//                                         return <ReportShowButton {...this.props} reportCode={record._docType} parameters={{ _docNum: record._docNum, _pos: record._docPos }} buttonText={text} />
//                                     } else {
//                                         return <span style={{ color: "blue", cursor: "pointer" }} onClick={() => this.handleDocIcon(record)}>{text}</span>
//                                     }
//                                 }
//                             },
//                         ]}  
//                     />}
//                 </GenericModal>
//             </div>
//         );
//     }
// }


class TipsDisplay extends Component {

    render() {
        return "בפיתוח..."
    }
}

export default TipsDisplay;